import { IMAGE_BASE_URL } from "constants/configConstants";

export const MAP_TYPES = {
  ROAD_VIEW: "ROAD_VIEW",
  STREET_VIEW: "STREET_VIEW",
} as const;

export const LIMIT_NEARBY_LOCATION = 4;

export const nearbyLocationFilterOptions = [
  {
    value: "universities",
    name: "Nearby Universities",
    icon: "icon-graduation-cap-square",
    marker_icon: { url: `${IMAGE_BASE_URL}shop-marker.svg`, scaledSize: { width: 30, height: 30 } },
    skip: true,
  },
  {
    value: "store",
    name: "Supermarket",
    filter: { radius: 16000, type: ["store"] },
    icon: "icon-cart-shopping-squar",
    marker_icon: { url: `${IMAGE_BASE_URL}shop-marker.svg`, scaledSize: { width: 30, height: 30 } },
  },
  {
    value: "restaurant",
    name: "Restaurant",
    filter: { radius: 16000, type: ["restaurant"] },
    icon: "icon-pot-food-square",
    marker_icon: {
      url: `${IMAGE_BASE_URL}restaurant-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "subway_station",
    name: "Train Station",
    filter: { radius: 16000, type: ["subway_station"] },
    icon: "icon-commute-square",
    marker_icon: {
      url: `${IMAGE_BASE_URL}Metro-Marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "bus_station",
    name: "Bus Station",
    filter: { radius: 16000, type: ["bus_station"] },
    icon: "icon-bus-square",
    marker_icon: {
      url: `${IMAGE_BASE_URL}commute-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "pharmacy",
    name: "Pharmacy",
    filter: { radius: 16000, type: ["pharmacy"] },
    icon: "icon-medical-facility",
    marker_icon: {
      url: `${IMAGE_BASE_URL}medical-facility.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "hospital",
    name: "Hospital",
    filter: { radius: 16000, type: ["hospital"] },
    icon: "icon-hospital",
    marker_icon: {
      url: `${IMAGE_BASE_URL}hospital-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "police",
    name: "Police Station",
    filter: { radius: 16000, type: ["police"] },
    icon: "icon-police",
    marker_icon: {
      url: `${IMAGE_BASE_URL}police-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "shopping_mall",
    name: "Shopping Mall",
    filter: { radius: 16000, type: ["shopping_mall"] },
    icon: "icon-shopping-mall",
    marker_icon: {
      url: `${IMAGE_BASE_URL}shopping-mall-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
];

export default nearbyLocationFilterOptions;
